import * as React from 'react';
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import SortableItemsTable from "./SortableItemsTable";

export default class DictionarySortableItemsTable extends SortableItemsTable<DictionaryItem> {


	renderHeaderBody() {
		return (
			<React.Fragment>
				<th>Id</th>
				<th>Name</th>
			</React.Fragment>
		)
	}

	renderRowBody(item: DictionaryItem) {
		return (
			<React.Fragment>
				<td style={{width: "50%"}}>{item.id}</td>
				<td style={{width: "50%"}}>{item.name}</td>
			</React.Fragment>
		)
	};

	itemToId(item: DictionaryItem): string {
		return item.id;
	}
}

